import z from 'zod';
import { languageSchema } from '@app/schemas/language';

export const sizeSchema = z.string().regex(/^\d+(\.\d+)?(px|em|rem|%)$/, {
  message: 'Size must be a valid CSS size (e.g., 10px, 1.5em, 100%)',
}).max(8, {
  message: 'Size string is too long',
});

z.globalRegistry.add(sizeSchema, { id: 'size' });

export type SizeSchema = z.infer<typeof sizeSchema>;

export const sizeTranslatableSchema = z.object({
  fallback: languageSchema,
  translations: z.record(languageSchema, sizeSchema),
});

z.globalRegistry.add(sizeTranslatableSchema, { id: 'size-translatable' });

export type SizeTranslatableSchema = z.infer<typeof sizeTranslatableSchema>;

export const sizeActivatableTranslatableSchema = z.object({
  normal: sizeTranslatableSchema,
  active: sizeTranslatableSchema.optional(),
});

z.globalRegistry.add(sizeActivatableTranslatableSchema, { id: 'size-activatable-translatable' });

export type SizeActivatableTranslatableSchema = z.infer<typeof sizeActivatableTranslatableSchema>;
